import { Descriptions, DescriptionsProps } from 'antd'
import styled from 'styled-components'

const StyledDescription: React.FC<DescriptionsProps> = styled(Descriptions)`
  background-color: white;
  padding: 10px;
  border-radius: 3px;
  /* border: 1px solid rgba(0, 0, 0, 0.1); */
  margin: 0;
  /* box-shadow: 3px 2px 3px rgba(0, 0, 0, 0.2); */
`

export default StyledDescription
